import React from 'react';
import { ArrowRight } from 'lucide-react';
import type { FormField, WelcomeScreenConfig, ThemeConfig } from '../../../types/forms';
import { getButtonStyles } from '../../../lib/themeUtils';

interface WelcomeScreenFieldProps {
  field: FormField;
  value?: string;
  onChange?: (value: string) => void;
  error?: string;
  disabled?: boolean;
  themeConfig?: ThemeConfig;
}

export const WelcomeScreenField: React.FC<WelcomeScreenFieldProps> = ({ field, disabled, themeConfig }) => {
  const config = field.config as WelcomeScreenConfig | undefined;
  const buttonText = config?.buttonText || 'Começar';

  return (
    <div className="py-6">
      <h2 className="text-3xl md:text-4xl font-bold mb-4" style={{ color: 'inherit' }}>{field.label}</h2>
      {field.helpText && (
        <p className="mb-8 text-lg" style={{ color: 'inherit', opacity: 0.6 }}>{field.helpText}</p>
      )}
      <button
        type="button"
        disabled={disabled}
        className={[
          'inline-flex items-center gap-2 font-medium transition-all duration-200',
          disabled ? 'cursor-default opacity-90' : 'hover:brightness-110',
        ].join(' ')}
        style={getButtonStyles(themeConfig, 'primary', 'lg')}
      >
        {buttonText}
        <ArrowRight className="w-4 h-4" />
      </button>
    </div>
  );
};
